export default {
  buildCardOrderAccountParams: ({
    atmAccess,
    cardAccountSignupId,
    cardName,
    cardholderAddress,
    countryOfCitizenship,
    dob,
    firstName,
    fundedByTrust,
    lastName,
    mobile,
    nonResidentAlien,
    shippingAddress,
    shippingDestination,
  }) => ({
    card_account_signup: { id: cardAccountSignupId },
    card_order: {
      address_attributes: {
        city: shippingAddress.city,
        state: shippingAddress.state,
        street1: shippingAddress.street1,
        street2: shippingAddress.street2,
        zip: shippingAddress.zip,
        address_type: 'mailing',
      },
      atm_access: atmAccess,
      cardholder_attributes: {
        address: {
          city: cardholderAddress.city,
          state: cardholderAddress.state,
          street1: cardholderAddress.street1,
          street2: cardholderAddress.street2,
          zip: cardholderAddress.zip,
          address_type: 'home',
        },
        card_name: cardName,
        dob,
        first_name: firstName,
        last_name: lastName,
        country_of_citizenship: countryOfCitizenship,
        non_resident_alien: nonResidentAlien,
        mobile,
      },
      funded_by_trust: fundedByTrust,
      shipping_destination: shippingDestination || null,
    },
  }),

  buildShippingAccountParams: ({ shippingAddress, shippingDestination }) => ({
    card_order: {
      address_attributes: {
        city: shippingAddress.city,
        state: shippingAddress.state,
        street1: shippingAddress.street1,
        street2: shippingAddress.street2,
        zip: shippingAddress.zip,
        address_type: 'mailing',
      },
      shipping_destination: shippingDestination,
    },
  }),

  mapServerAccountToClientAccount: ({ id, relationships, attributes }) => {
    const { cardholder, shipping_address } = relationships;
    return {
      id,
      ...attributes,
      shippingAddress: shipping_address
        ? {
            id: shipping_address.data.id,
            ...shipping_address.data.attributes,
          }
        : null,
      cardholder: cardholder
        ? {
            id: cardholder.data.id,
            ...cardholder.data.attributes,
            address: cardholder.data.relationships.address && {
              id: cardholder.data.relationships.address.data.id,
              ...cardholder.data.relationships.address.data.attributes,
            },
          }
        : null,
    };
  },

  mapServerCardAccountTrustToClientCardAccountTrust: ({ id, relationships, attributes }) => {
    const { address } = relationships;
    return {
      id,
      ...attributes,
      address: address
        ? {
            id: address.data.id,
            ...address.data.attributes,
          }
        : null,
    };
  },
};
